module.exports = __webpack_public_path__ + "img/kemptnerkopf.5f7b188f.jpg";